import $ from 'jquery';



export const homepageScroll = () => {

	const legacyIsMobileCheck = () => {
		return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
	}

	const uaDataIsMobile = window.navigator.userAgentData?.mobile;
	const isMobile = typeof uaDataIsMobile === 'boolean'
		? uaDataIsMobile
		: legacyIsMobileCheck(window.navigator.userAgent);

	const header = document.querySelector('.header');
	const carousel = document.querySelector('.carousel--solutions');

	if (carousel) {
		let carouselTopOffset = $(carousel).offset().top;
		let carouselHeight = $(carousel).height();
		let windowTopOffset = $(window).scrollTop();
		let windowHeight = $(window).height();
		let oldWindowPosition = window.scrollY;
		let isInViewport = false;
		let firstSlide = true;
		let lastSlide = false;
		let touchStartPostition;
		let isMoving = false;
		let isAnimating = false;

		$(carousel).on('afterChange', function (event, slick, currentSlide) {
			if (currentSlide == 0) {
				firstSlide = true;
				lastSlide = false;
			} else if (slick.$slides.length - 1 == currentSlide) {
				firstSlide = false;
				lastSlide = true;
			} else {
				firstSlide = false;
				lastSlide = false;
			}
		});

		const hideHeaderOverCarousel = () => {
			$(header).addClass('header--hide');
		}

		const checkCarouselPosition = () => {
			let windowTopOffsetLocal = $(window).scrollTop();

			if ((carouselTopOffset + carouselHeight) >= window.scrollY 
				&& carouselTopOffset < (window.scrollY - 5) 
				&& carouselTopOffset !== window.scrollY 
				&& windowTopOffsetLocal !== 0) 
			{
				scrollToSectionTop();
			}

			if (carouselTopOffset > (window.scrollY + 5) 
				&& carouselTopOffset !== window.scrollY 
				&& windowTopOffsetLocal !== 0) 
			{
				scrollToSectionTop();
			}
		}

		const scrollToSectionTop = () => {
			animateWindowScroll($(carousel).offset().top);
		}

		const stopMomentumScrollFunc = () => {
			let windowScrollY = window.scrollY;

			const stopMomentumScrollInterval = setInterval(() => {
				if (windowScrollY !== $(carousel).offset().top && windowScrollY > $(carousel).offset().top && isMobile) {
					windowScrollY = window.scrollY;
					animateWindowScroll($(carousel).offset().top);
				} else {
					clearInterval(stopMomentumScrollInterval);
				}
			}, 600);
		}

		const animateWindowScroll = (pos) => {
			if (isAnimating) {
				return;	
			}

			isAnimating = true;

			$('html, body').animate({
				scrollTop: pos
			}, 500, () => {
				isAnimating = false;
			});

            console.trace();
		}

		const scrollOnCarousel = () => {
			
			$(carousel).on('scroll wheel', (function (e) {
				e.preventDefault();

				hideHeaderOverCarousel();

				if (e.originalEvent.deltaY < 0 
					&& isInViewportFunc() == true 
					&& firstSlide == false) 
				{
					$(carousel).slick('slickPrev');
				}

				if (e.originalEvent.deltaY > 0 
					&& isInViewportFunc() == true 
					&& lastSlide == false) 
				{
					$(carousel).slick('slickNext');
				}

				if (e.originalEvent.deltaY < 0 
					&& firstSlide == true 
					&& isInViewportFunc() == true) 
				{
					animateWindowScroll(0);
				}

				if (e.originalEvent.deltaY > 0 
					&& lastSlide == true 
					&& isInViewportFunc() == true) 
				{
					animateWindowScroll(($(window).scrollTop() + $(carousel).outerHeight()) + 10 + 'px');
				}
			}));
		};

		const isInViewportFunc = () => {
			const distance = Math.abs(carouselTopOffset - window.scrollY);
			return distance < 20 || distance > 20;
		}

		const onCarouselTouchStart = (e) => {
			e.preventDefault();
			e.stopPropagation();
			touchStartPostition = e.originalEvent.touches[0].clientY;
			$(carousel).on('touchmove', onCarouselTouchMove);
		}
		
		const onCarouselTouchMove = (e) => {
			e.preventDefault();
			e.stopPropagation();

			isMoving = true;
			let touchMovePosition = e.originalEvent.changedTouches[0].clientY;

			hideHeaderOverCarousel();

			if (touchStartPostition > touchMovePosition && isInViewportFunc() == true) {
				$(carousel).slick('slickNext');
				onCarouselTouchEnd();
			}

			if (touchStartPostition < touchMovePosition && isInViewportFunc() == true) {
				$(carousel).slick('slickPrev');
				onCarouselTouchEnd();
			}

			if (touchStartPostition > touchMovePosition 
				&& lastSlide == true 
				&& isInViewportFunc() == true) 
			{
				animateWindowScroll(($(window).scrollTop() + $(carousel).outerHeight()) + 10 + 'px');
				onCarouselTouchEnd();
			}

			if (touchStartPostition < touchMovePosition 
				&& firstSlide == true 
				&& isInViewportFunc() == true) 
			{
				animateWindowScroll(0);
				onCarouselTouchEnd();
			}
		}

		const onCarouselTouchEnd = (e) => {
			$(carousel).off('touchmove', onCarouselTouchMove);
		}

		const touchOnCarousel = () => {
			onCarouselTouchEnd();
			$(carousel).on('touchstart', onCarouselTouchStart);
		}

		if ($(window).width() >= 768) {
			$(window).on('touchend', onCarouselTouchEnd);

			touchOnCarousel();
		};

		const scrolling = (event) => {
			let delta = window.scrollY - oldWindowPosition;
			let isInViewportLocal = carouselTopOffset === window.scrollY;

			if (isInViewportLocal) {
				event.preventDefault();
			}

			if ((carouselTopOffset + carouselHeight) >= window.scrollY 
				&& delta < 0 
				&& carouselTopOffset < (window.scrollY - 5) 
				&& carouselTopOffset !== window.scrollY 
				&& isInViewportFunc() == true) 
			{
				scrollToSectionTop();
				if ($(window).width() <= 1239) {
					stopMomentumScrollFunc();
				}
			}

			if (delta > 0 
				&& carouselTopOffset > (window.scrollY + 50)
				&& carouselTopOffset !== window.scrollY 
				&& isInViewportFunc() == true) 
			{
				scrollToSectionTop();
				if ($(window).width() <= 1239) {
					stopMomentumScrollFunc();
				}
			}

			if (isInViewportFunc() == true) {
				scrollOnCarousel();
			} else {
				$(carousel).unbind('scroll wheel');
			}

			oldWindowPosition = window.scrollY;
		};

		if ($(window).width() >= 768) {
			window.onload = (e) => {
				checkCarouselPosition();
			};

			window.addEventListener('wheel', ((e) => {
				scrolling(e);
			}), { passive: false });

			window.addEventListener('mouseup', () => {
				if (window.scrollY !== 0) {
					checkCarouselPosition();
				}
			});
		}

		if ($(window).width() >= 768 && $(window).width() <= 1239) {
			window.addEventListener('scroll', ((e) => {
				scrolling(e);
			}), { passive: false });
		}
	}
};
